import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MenuItem } from 'primeng/api'
import { NavmenuItem } from './navmenu-item'

@Component({
  selector: 'basin-navmenu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.scss'],
})
export class NavmenuComponent implements OnInit, AfterViewInit, OnChanges {
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth <= 600) {
      this.mobile = true
    } else {
      this.mobile = false
    }
  }
  @Input() dropdownMenuSelector: boolean = false
  @Input() dropdownMenuItems: MenuItem[] = []
  @Input() footerMenuItems: MenuItem[] = []
  @Input() menuThemeColor: string = ''
  @Input() stantecLensClickable: boolean
  @Input() logo: string = ''
  @Input() logoClickable: boolean
  @Input() homeLink: boolean = true
  @Input() homeLinkClickable: boolean
  @Input() homeLinkText: string
  @Input() currentPageTitle: string
  @Input() selectedDropdownMenuItem: MenuItem

  private _navItems: NavmenuItem[] = []
  public get navItems(): NavmenuItem[] {
    return this._navItems
  }
  @Input() set navItems(v: NavmenuItem[]) {
    this._navItems = v
    this.checkForScrollbar()
  }

  @Input() displayHeaderIcon = false
  @Input() showProfile: boolean = true
  @Input() userProfile: any = {}
  @Input() profileMenuItems: MenuItem[] = []
  @Input() ellipsesMenu: boolean = true
  @Input() ellipsesMenuItems: MenuItem[] = []
  @Input() headerMenuIcon: string
  @Input() headerMenuItems: MenuItem[]
  @Output() dockNavmenu: EventEmitter<any> = new EventEmitter()
  @Output() unDockNavmenu: EventEmitter<any> = new EventEmitter()
  @Output() stantecLensClick: EventEmitter<Event> = new EventEmitter<Event>()
  @Output() logoClick: EventEmitter<Event> = new EventEmitter<Event>()
  @Output() homeLinkClick: EventEmitter<Event> = new EventEmitter<Event>()
  mappedDropdownMenuItems: MenuItem[]
  mobile: boolean
  expanded: boolean = false
  inMenu: boolean = false
  mobileMenuOpen: boolean = false

  headerMenuIsOpen: boolean = false
  hovered: boolean = false

  ellipsesMenuIsOpen: boolean = false
  profileMenuIsOpen: boolean = false

  ngOnInit(): void {
    this.onResize()
    this.mapDropdownMenuItems()
  }

  ngAfterViewInit(): void {
    this.checkForScrollbar()
  }

  ngOnChanges(): void {
    this.mapDropdownMenuItems()
  }

  mapDropdownMenuItems() {
    this.mappedDropdownMenuItems = this.dropdownMenuItems?.map(
      (item: MenuItem) => {
        return {
          ...item,
          command: (event) => {
            this.selectedDropdownMenuItem = item
            if (item.command) {
              item.command(event)
            }
          },
        }
      }
    )
    if (!this.selectedDropdownMenuItem) {
      this.selectedDropdownMenuItem = this.mappedDropdownMenuItems?.[0]
    }
  }

  addHover(): void {
    this.hovered = true
  }

  removeHover(): void {
    this.hovered = false
  }

  addInMenu(): void {
    this.inMenu = true
  }

  removeInMenu(): void {
    this.inMenu = false
  }

  addDock(): void {
    this.dockNavmenu.emit(true)
    this.expanded = true
    this.mobileMenuOpen = true
  }

  removeDock(): void {
    this.unDockNavmenu.emit(true)
    this.expanded = false
    this.mobileMenuOpen = false
  }

  toggleMenu(): void {
    if (this.mobile) {
      this.mobileMenuOpen = !this.mobileMenuOpen
      this.expanded = !this.expanded
    }
  }

  stantecLensClicked(event: Event): void {
    this.stantecLensClick.emit(event)
  }

  logoClicked(event: Event): void {
    this.logoClick.emit(event)
  }

  homeLinkClicked(event: Event): void {
    this.homeLinkClick.emit(event)
  }

  shouldAddDivider(index: number): boolean {
    const currentItem = this.navItems[index]
    const nextItem = this.navItems[index + 1]

    if (!nextItem) return false

    return (
      (!!currentItem.header && !nextItem.header) ||
      (!currentItem.header && !!nextItem.header)
    )
  }

  @ViewChild('scrollBody') scrollContainer!: ElementRef

  hasScrollbar = false

  private checkForScrollbar() {
    const element = this.scrollContainer?.nativeElement
    if (element) {
      this.hasScrollbar = element.scrollHeight > element.clientHeight
    }
  }
}
